<template>
  <div class="container">
    <!-- Hero：左侧文案 + 右侧下载卡片 -->
    <div class="con-hero">
      <img class="hero-bg" v-lazy="require('@/assets/download/hero-bg.png')" alt="" />
      <div class="hero-inner">
        <div class="hero-left">
          <div class="hero-title">
            <span>丰派应用</span><span class="blue">下载</span><span>中心</span>
          </div>
          <div class="hero-subtitle">你要的都在这，快速下载全部应用</div>
          <div class="hero-platform">支持 iOS、Android、Windows、微信小程序</div>
          <div class="hero-stats">
            <img class="stats-icon" :src="require('@/assets/download/stats-icon.svg')" alt="" />
            <span class="stats-num">1000+</span>
            <span class="stats-text">企业正在使用丰派产品提升经营效率</span>
          </div>
          <div class="hero-actions">
            <div class="btn-download" @click="openWinMask">
              <img class="btn-icon" :src="require('@/assets/download/btn-download-icon.png')" alt="" />
              <span>立即下载</span>
            </div>
            <div class="link-version" @click="openWinMask">
              <span>版本说明</span>
              <img class="arrow-icon" :src="require('@/assets/download/arrow-right.svg')" alt="" />
            </div>
          </div>
        </div>
        <div class="hero-right">
          <div class="down-row">
            <div class="down-item">
              <img class="appiconback" src="@/assets/newdownload/appback1.png" alt="" />
              <div class="pos-icon">
                <img class="appicon" src="@/assets/newdownload/appicon1.png" alt="" />
                <span class="appname">Windows</span>
                <img class="downicon" src="@/assets/newdownload/downicon.png" alt="" />
              </div>
              <div class="showdown">
                <div class="downselect">
                  <div class="dsitem" @click="clickdownloadWin">
                    <div class="dsname">稳定版【Reliable】</div>
                  </div>
                  <div class="dsitem" @click="clickdownloadWinNew">
                    <div class="dsname">最新版【New】</div>
                  </div>
                </div>
                <div class="downselectword" @click.stop="openWinMask">版本选择和注意事项！</div>
              </div>
            </div>
            <div class="down-item">
              <img class="appiconback" src="@/assets/newdownload/appback2.png" alt="" />
              <div class="pos-icon">
                <img class="appicon" src="@/assets/newdownload/appicon2.png" alt="" />
                <span class="appname">Android</span>
                <img class="downicon" src="@/assets/newdownload/downicon.png" alt="" />
              </div>
              <div class="showdown">
                <div class="downselect">
                  <div class="dsitem" @click="clickdownloadAndroid">
                    <div class="dsname">稳定版【Reliable】</div>
                  </div>
                  <div class="dsitem" @click="clickdownloadAndroidNew">
                    <div class="dsname">最新版【New】</div>
                  </div>
                </div>
                <div class="downselectword" @click.stop="openWinMask">版本选择和注意事项！</div>
              </div>
            </div>
            <div class="down-item">
              <img class="appiconback" src="@/assets/newdownload/appback2.png" alt="" />
              <img class="downiconword" src="@/assets/newdownload/downiconword.png" alt="" />
              <div class="pos-icon">
                <img class="appicon" src="@/assets/newdownload/appicon3.png" alt="" />
                <span class="appname">收银手机后台</span>
                <img class="downicon code" src="@/assets/newdownload/downiconcode.png" alt="" />
              </div>
              <div class="showdown">
                <div class="sdcode">
                  <img class="showqrcode" src="@/assets/newdownload/showqrcode.png" alt="" />
                </div>
                <div class="downselectword code">扫码下载APP</div>
              </div>
            </div>
          </div>
          <div class="down-row">
            <div class="down-item">
              <img class="appiconback" src="@/assets/newdownload/appback3.png" alt="" />
              <div class="pos-icon">
                <img class="appicon" src="@/assets/newdownload/appicon4.png" alt="" />
                <span class="appname">自助收银</span>
                <img class="downicon" src="@/assets/newdownload/downicon.png" alt="" />
              </div>
              <div class="showdown">
                <div class="downselect">
                  <div class="dsitem" @click="$message.warning('暂未开放')">
                    <div class="dsname">Windows版本</div>
                  </div>
                  <div class="dsitem" @click="clickdownloadBySelf">
                    <div class="dsname">Android版本</div>
                  </div>
                </div>
                <div class="downselectword">选择下载版本</div>
              </div>
            </div>
            <div class="down-item">
              <img class="appiconback" src="@/assets/newdownload/appback3.png" alt="" />
              <div class="pos-icon">
                <img class="appicon" src="@/assets/newdownload/appicon5.png" alt="" />
                <span class="appname">远程工具</span>
                <img class="downicon" src="@/assets/newdownload/downicon.png" alt="" />
              </div>
              <div class="showdown">
                <div class="downselect">
                  <div class="dsitem" @click="clickdownloadWinRemote">
                    <div class="dsname">Windows版本</div>
                  </div>
                  <div class="dsitem" @click="clickdownloadWinVoice">
                    <div class="dsname">Android版本</div>
                  </div>
                </div>
                <div class="downselectword">选择下载版本</div>
              </div>
            </div>
            <div class="down-item">
              <img class="appiconback" src="@/assets/newdownload/appback1.png" alt="" />
              <div class="pos-icon">
                <img class="appicon test" :src="require('@/assets/download/test-icon.svg')" alt="" />
                <span class="appname">测试版本</span>
                <img class="downicon" src="@/assets/newdownload/downicon.png" alt="" />
              </div>
              <div class="showdown">
                <div class="downselect">
                  <div class="dsitem" @click="clickdownloadAndroidNew">
                    <div class="dsname">Android版本</div>
                  </div>
                  <div class="dsitem" @click="clickdownloadWinNew">
                    <div class="dsname">Windows版本</div>
                  </div>
                </div>
                <div class="downselectword">选择下载版本</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 订货平台 + 扫码体验 -->
    <div class="con-bottom">
      <div class="bottom-inner">
        <div class="platform-section">
          <div class="section-head">
            <div class="section-title">订货平台应用</div>
            <div class="section-tip">更多业务请咨询业务员</div>
          </div>
          <div class="platform-cards">
            <div
              class="platform-card"
              v-for="item in platformList"
              :key="item.title"
            >
              <img class="platform-bg" v-lazy="item.bg" alt="" />
              <img class="platform-icon" v-lazy="item.icon" alt="" />
              <div class="platform-name">{{ item.title }}</div>
              <div class="platform-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
        <div class="scan-section">
          <div class="section-title">扫码体验</div>
          <div class="scan-cards">
            <div class="scan-card" v-for="item in scanList" :key="item.title">
              <img class="scan-bg" v-lazy="require('@/assets/download/scan-card-bg.png')" alt="" />
              <img class="scan-qrcode" v-lazy="item.qrcode" alt="" />
              <div class="scan-info">
                <div class="scan-title" v-html="item.title"></div>
                <div class="scan-link">微信扫码进入</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部特性 -->
      <div class="feature-row">
        <div class="feature-item" v-for="(item, index) in featureList" :key="item.title">
          <img class="feature-icon" v-lazy="item.icon" alt="" />
          <div class="feature-text">
            <div class="feature-title">{{ item.title }}</div>
            <div class="feature-desc">{{ item.desc }}</div>
          </div>
          <div class="feature-divider" v-if="index < featureList.length - 1"></div>
        </div>
      </div>
    </div>

    <!-- 版本选择弹窗 -->
    <div class="helpMask" v-if="helpview" @click.stop="closeHelpModal">
      <div class="helpModal" @click.stop="">
        <div class="modal-close">
          <div></div>
          <img
            class="close"
            src="@/assets/newdownload/close.png"
            alt=""
            @click.stop="closeHelpModal"
          />
        </div>
        <div class="modal-top">
          <div class="modal-tit">选择适合您的收银应用版本</div>
          <div class="modal-btn">
            <div class="btn-down blue" @click.stop="downloadSaleVersion">
              下载稳定版
            </div>
            <div class="btn-down" @click.stop="downloadAiVersion">
              下载最新版
            </div>
          </div>
        </div>
        <div class="modal-tip">
          <div class="mt-line">
            <img class="mt-icon" :src="require('@/assets/download/modal-icon-stable.svg')" alt="" />
            <div class="mt-text">
              <span class="label">稳定版：</span>经过1000+门店市场验证，适合要求高对“稳”字优先的使用场景。
            </div>
          </div>
          <div class="mt-line">
            <img class="mt-icon" :src="require('@/assets/download/modal-icon-new.svg')" alt="" />
            <div class="mt-text">
              <span class="label">最新版：</span>拥有产品最新上线功能，快速迭代，持续释放生产力，适合新业态追求新玩法。
            </div>
          </div>
          <div class="mt-line">
            <img class="mt-icon" :src="require('@/assets/download/modal-icon-warning.svg')" alt="" />
            <div class="mt-text">
              <span class="label">注意事项：</span>若您安装过最新版收银应用，现要切换为稳定版，请先卸载最新版再安装，请勿直接下载覆盖安装，覆盖安装可能导致新旧版软件残留数据报错。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "idownload",
  data() {
    return {
      helpview: false,
      versionType: 1,
      platformList: [
        {
          title: "智慧零售小程序",
          desc: "商城+门店+社区团购",
          bg: require("@/assets/download/platform-bg-1.png"),
          icon: require("@/assets/download/platform-icon-1.png"),
        },
        {
          title: "管理后台小程序",
          desc: "管理+协作",
          bg: require("@/assets/download/platform-bg-2.png"),
          icon: require("@/assets/download/platform-icon-2.png"),
        },
        {
          title: "订货商城小程序",
          desc: "在线订货",
          bg: require("@/assets/download/platform-bg-3.png"),
          icon: require("@/assets/download/platform-icon-3.png"),
        },
        {
          title: "订货管理APP",
          desc: "店务管理",
          bg: require("@/assets/download/platform-bg-4.png"),
          icon: require("@/assets/download/platform-icon-4.png"),
        },
      ],
      scanList: [
        {
          title: "丰派云pos<br/>后台小程序",
          qrcode: require("@/assets/newdownload/wxcode.png"),
        },
        {
          title: "收银微商城体验小程序",
          qrcode: require("@/assets/newdownload/twxcode.png"),
        },
      ],
      featureList: [
        {
          title: "安全可靠",
          desc: "数据加密  权限保障",
          icon: require("@/assets/download/feature-1.png"),
        },
        {
          title: "稳定高效",
          desc: "7x24小时稳定运行",
          icon: require("@/assets/download/feature-2.png"),
        },
        {
          title: "专业服务",
          desc: "一对一技术支持",
          icon: require("@/assets/download/feature-3.png"),
        },
        {
          title: "持续更新",
          desc: "功能迭代  持续优化",
          icon: require("@/assets/download/feature-4.png"),
        },
      ],
    };
  },
  activated() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  methods: {
    clickdownloadWin() {
      let elink = document.createElement("a");
      elink.download = "Windows版本下载";
      elink.style.display = "none";
      elink.href = "https://oss.fp1123.com/fp_pos_win_net/%E4%B8%B0%E6%B4%BE%E4%BA%91POS%20Setup%201.23.6.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadWinNew() {
      let elink = document.createElement("a");
      elink.download = "Windows版本下载";
      elink.style.display = "none";
      elink.href =
        "https://oss.fp1123.com/fp_pos_win_net/%E4%B8%B0%E6%B4%BE%E4%BA%91POS%20Setup%201.23.6.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadBySelf() {
      let elink = document.createElement("a");
      elink.download = "自助收银版本下载";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/fp_pos_auto/fp_pos_auto.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadai() {
      let elink = document.createElement("a");
      elink.download = "Windows版本下载ai";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/fp_pos_win_ai/丰派云POS_AI Setup 1.5.0.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadWinVoice() {
      let elink = document.createElement("a");
      elink.download = "远程工具 ";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/fp_help/fp_help.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadWinRemote() {
      let elink = document.createElement("a");
      elink.download = "Windows远程工具 ";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/fp_help/fprjwin.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadAndroid() {
      let elink = document.createElement("a");
      elink.download = "Android版本下载";
      elink.style.display = "none";
      elink.href = "https://oss.fp1123.com/fp_pos_android/fp_pos_android.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadAndroidNew() {
      let elink = document.createElement("a");
      elink.download = "Android版本下载";
      elink.style.display = "none";
      elink.href =
        "https://oss.fp1123.com/fp_pos_android_latest/fp_pos_android.apk ";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadAndroidAi() {
      let elink = document.createElement("a");
      elink.download = "Android Ai版本下载";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/fp_pos_android_ai/fp_pos_android_ai.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    closeHelpModal() {
      this.helpview = false;
    },
    openWinMask() {
      this.helpview = true;
      this.versionType = 1;
    },
    downloadSaleVersion() {
      if (this.versionType == 1) {
        this.clickdownloadWin();
      } else {
        this.clickdownloadAndroid();
      }
    },
    downloadAiVersion() {
      if (this.versionType == 1) {
        this.clickdownloadWinNew();
      } else {
        this.clickdownloadAndroidNew();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  top: 64px;
  width: 100%;
  min-width: 1440px;
  background: #ffffff;
}

.mixin-word() {
  font-family: "Noto Sans SC", sans-serif;
  font-style: normal;
  font-weight: 400;
  color: #292929;
}

.con-hero {
  position: relative;
  width: 100%;
  overflow: hidden;

  .hero-bg {
    position: absolute;
    top: -10%;
    left: 0;
    width: 100%;
    height: auto;
    min-height: 100%;
    object-fit: cover;
    pointer-events: none;
  }

  .hero-inner {
    position: relative;
    z-index: 1;
    width: 1440px;
    margin: 0 auto;
    padding: 80px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .hero-left {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .hero-title {
    .mixin-word;
    font-weight: 700;
    font-size: 64px;
    line-height: 1.2;
    white-space: nowrap;

    .blue {
      color: #336fff;
    }
  }

  .hero-subtitle {
    .mixin-word;
    font-size: 32px;
    line-height: 1.4;
    color: #343030;
  }

  .hero-platform {
    .mixin-word;
    font-size: 24px;
    line-height: 1.4;
    color: #69717e;
  }

  .hero-stats {
    display: flex;
    align-items: center;
    gap: 8px;

    .stats-icon {
      width: 28px;
      height: 28px;
    }

    .stats-num {
      .mixin-word;
      font-weight: 700;
      font-size: 20px;
      line-height: 28px;
      color: #336fff;
    }

    .stats-text {
      .mixin-word;
      font-size: 20px;
      line-height: 28px;
      color: #637392;
    }
  }

  .hero-actions {
    display: flex;
    align-items: center;
    gap: 40px;
  }

  .btn-download {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 40px;
    background: #336fff;
    box-shadow: 8px 8px 10px rgba(55, 99, 170, 0.1);
    border-radius: 6px;

    .btn-icon {
      width: 24px;
      height: 24px;
    }

    span {
      .mixin-word;
      font-size: 24px;
      line-height: 32px;
      color: #ffffff;
    }

    &:hover {
      background: #5c8cff;
    }
  }

  .link-version {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;

    span {
      .mixin-word;
      font-size: 20px;
      line-height: 28px;
      color: #336fff;
    }

    .arrow-icon {
      width: 24px;
      height: 24px;
      transform: rotate(180deg);
    }
  }

  .hero-right {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .down-row {
    display: flex;
    align-items: center;
    gap: 24px;
  }

  .down-item {
    width: 220px;
    height: 220px;
    overflow: hidden;
    position: relative;
    filter: drop-shadow(0px 18px 21.5px rgba(74, 130, 183, 0.15));
    border-radius: 20px;

    &:hover .showdown {
      display: flex;
    }

    &:hover .pos-icon {
      display: none;
    }
  }

  .appiconback {
    width: 220px;
    height: 220px;
    border-radius: 20px;
  }

  .downiconword {
    height: 24px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 20;
  }

  .pos-icon {
    width: 220px;
    height: 220px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .appname {
      margin-top: 10px;
      .mixin-word;
      font-weight: 500;
      font-size: 22px;
      line-height: 33px;
      text-align: center;
      color: #ffffff;
    }

    .appicon {
      width: 100px;
      height: 100px;

      &.test {
        object-fit: contain;
      }
    }

    .downicon {
      width: 36px;
      height: 36px;
      cursor: pointer;
      position: absolute;
      top: 10px;
      right: 10px;

      &.code {
        width: 64px;
        height: 64px;
        top: 0;
        right: 0;
      }
    }
  }

  .showdown {
    display: none;
    width: 220px;
    height: 220px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .downselect {
      padding: 12px;
      width: 188px;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 0px 18px 43px rgba(74, 130, 183, 0.15);
      border-radius: 12px;

      .dsitem {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 12px;
        height: 64px;
        cursor: pointer;

        .dsname {
          .mixin-word;
          font-size: 16px;
          line-height: 26px;
        }

        &:hover {
          background: #ffffff;

          .dsname {
            color: #336fff;
          }
        }
      }
    }

    .sdcode {
      width: 140px;
      height: 140px;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 0px 18px 43px rgba(74, 130, 183, 0.15);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;

      .showqrcode {
        width: 100px;
        height: 100px;
      }
    }

    .downselectword {
      margin-top: 12px;
      .mixin-word;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #ffffff;
      cursor: pointer;

      &.code {
        margin-top: 4px;
        cursor: default;
      }
    }
  }
}

.con-bottom {
  width: 100%;
  background: #ffffff;
  padding: 40px 0;

  .bottom-inner {
    width: 1440px;
    margin: 0 auto;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    height: 240px;
  }

  .platform-section {
    background: #f5f8fd;
    border-radius: 16px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    margin-right: 24px;
    min-width: 0;
  }

  .section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .section-title {
    .mixin-word;
    font-weight: 700;
    font-size: 24px;
    line-height: 1.4;
  }

  .section-tip {
    .mixin-word;
    font-size: 14px;
    color: #69717e;
  }

  .platform-cards {
    display: flex;
    gap: 20px;
    flex: 1;
  }

  .platform-card {
    position: relative;
    width: 160px;
    height: 160px;
    border: 4px solid #ffffff;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .platform-bg {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 12px;
    }

    .platform-icon {
      position: relative;
      z-index: 1;
      width: 80px;
      height: 80px;
      object-fit: contain;
    }

    .platform-name {
      position: relative;
      z-index: 1;
      .mixin-word;
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      margin-top: 4px;
    }

    .platform-desc {
      position: relative;
      z-index: 1;
      .mixin-word;
      font-size: 14px;
      line-height: 22px;
      color: #637392;
      text-align: center;
    }
  }

  .scan-section {
    background: #ffffff;
    border: 1px solid #c6d3dd;
    border-radius: 16px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex-shrink: 0;
    width: 688px;
  }

  .scan-cards {
    display: flex;
    gap: 24px;
    flex: 1;
  }

  .scan-card {
    position: relative;
    width: 320px;
    height: 160px;
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 0 24px;
    gap: 12px;
    filter: drop-shadow(0px 10px 15px #dbebfc);

    .scan-bg {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .scan-qrcode {
      position: relative;
      z-index: 1;
      width: 132px;
      height: 132px;
      flex-shrink: 0;
    }

    .scan-info {
      position: relative;
      z-index: 1;
      flex: 1;
    }

    .scan-title {
      .mixin-word;
      font-size: 22px;
      line-height: 30px;
    }

    .scan-link {
      margin-top: 8px;
      .mixin-word;
      font-size: 16px;
      line-height: 24px;
      color: #336fff;
    }
  }

  .feature-row {
    width: 1200px;
    margin: 40px auto 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .feature-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    position: relative;
  }

  .feature-icon {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    object-fit: contain;
  }

  .feature-text {
    .feature-title {
      .mixin-word;
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
    }

    .feature-desc {
      .mixin-word;
      font-size: 14px;
      line-height: 22px;
      color: #637392;
      white-space: pre;
    }
  }

  .feature-divider {
    position: absolute;
    right: -4px;
    width: 2px;
    height: 40px;
    background: #dae0eb;
  }
}

.helpMask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 30;

  .helpModal {
    width: 640px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;

    .modal-close {
      padding: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .close {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }

    .modal-top {
      width: 560px;
      align-self: center;
      border-bottom: 1px solid #d7dde0;
      padding-bottom: 40px;
    }

    .modal-tit {
      .mixin-word;
      font-size: 32px;
      line-height: 40px;
      text-align: center;
    }

    .modal-btn {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      .btn-down {
        width: 214px;
        height: 54px;
        background: #ffffff;
        border: 1px solid #d7dde0;
        border-radius: 4px;
        .mixin-word;
        font-size: 20px;
        line-height: 54px;
        cursor: pointer;
        text-align: center;

        &.blue {
          background: #336fff;
          color: #ffffff;
          border: none;
        }

        & + .btn-down {
          margin-left: 12px;
        }
      }
    }

    .modal-tip {
      width: 560px;
      margin: 0 auto;
      padding: 20px 40px 40px;
      display: flex;
      flex-direction: column;
      gap: 16px;

      .mt-line {
        display: flex;
        gap: 8px;
        align-items: flex-start;
      }

      .mt-icon {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        margin-top: 0;
      }

      .mt-text {
        .mixin-word;
        font-size: 14px;
        line-height: 20px;
        color: #292929;
        flex: 1;

        .label {
          color: #416bae;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/download.vue